/**
 * @flow
 * @relayHash bd227f8ac2049641b728be7b45dbe274
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type OpenEstimateContainer_viewer$ref = any;
export type ShareRoutes_OpenEstimate_QueryVariables = {||};
export type ShareRoutes_OpenEstimate_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: OpenEstimateContainer_viewer$ref
  |}
|};
export type ShareRoutes_OpenEstimate_Query = {|
  variables: ShareRoutes_OpenEstimate_QueryVariables,
  response: ShareRoutes_OpenEstimate_QueryResponse,
|};
*/


/*
query ShareRoutes_OpenEstimate_Query {
  viewer {
    ...OpenEstimateContainer_viewer
    id
  }
}

fragment OpenEstimateContainer_viewer on User {
  id
}
*/

const node/*: ConcreteRequest*/ = {
  "kind": "Request",
  "operationKind": "query",
  "name": "ShareRoutes_OpenEstimate_Query",
  "id": null,
  "text": "query ShareRoutes_OpenEstimate_Query {\n  viewer {\n    ...OpenEstimateContainer_viewer\n    id\n  }\n}\n\nfragment OpenEstimateContainer_viewer on User {\n  id\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ShareRoutes_OpenEstimate_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "OpenEstimateContainer_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ShareRoutes_OpenEstimate_Query",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
};
// prettier-ignore
(node/*: any*/).hash = '43125c13a8aa08d1011a5fee2fa54e89';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/routes/__generated__/ShareRoutes_OpenEstimate_Query.graphql.js